import { IS_ONLINE_RETURN, IS_CFR_RETURN } from './actionTypes';

export const toggleIsOnlineReturn = payload => dispatch => {
  dispatch({
    type: IS_ONLINE_RETURN,
    payload,
  });
};

export const toggleIsCFRReturn = payload => dispatch => {
  dispatch({
    type: IS_CFR_RETURN,
    payload,
  });
};
